const utils = {
  isObject: function (obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
  },
  // style name 转换为 驼峰式
  camelize: function (styleName) {
    let camelizeReg = /-(\w)/g;
    return styleName.replace(camelizeReg, (_, c) => {
      return c ? c.toUpperCase() : "";
    });
  },
  getStyle: function (element, styleName) {
    if (!element || !styleName) return "";
    styleName = this.camelize(styleName);
    if (styleName === "float") {
      styleName = "cssFloat";
    }
    try {
      const style = element.style[styleName];
      if (style) return style;
      const computed = document.defaultView?.getComputedStyle(element, "");
      return computed ? computed[styleName] : "";
    } catch (e) {
      return element.style[styleName];
    }
  },

  // element: HTMLElement,styleName: CSSProperties | string, value?: string
  setStyle: function (element, styleName, value) {
    if (!element || !styleName) return;
    if (this.isObject(styleName)) {
      Object.keys(styleName).forEach((prop) => {
        this.setStyle(element, prop, styleName[prop]);
      });
    } else {
      styleName = this.camelize(styleName);
      element.style[styleName] = value;
    }
  },

  // element: HTMLElement, style: CSSProperties | string
  removeStyle: function (element, style) {
    if (!element || !style) return;
    if (this.isObject(style)) {
      Object.keys(style).forEach((prop) => {
        this.setStyle(element, prop, "");
      });
    } else {
      this.setStyle(element, style, "");
    }
  },

  // el: HTMLElement,isVertical?: Nullable<boolean>
  isScroll: function (el, isVertical) {
    const determinedDirection = isVertical === null || isVertical === undefined;
    const overflow = determinedDirection
      ? this.getStyle(el, "overflow")
      : isVertical
      ? this.getStyle(el, "overflow-y")
      : this.getStyle(el, "overflow-x");
    return overflow.match(/(scroll|auto|overlay)/);
  },
  // el: HTMLElement, isVertical?: Nullable<boolean>
  getScrollContainer: function (el, isVertical) {
    let parent = el;
    while (parent) {
      if ([window, document, document.documentElement].includes(parent)) {
        return window;
      }
      if (this.isScroll(parent, isVertical)) {
        return parent;
      }
      parent = parent.parentNode;
    }
    return parent;
  },

  // el: Element | undefined,container: Element | Window | undefined
  isInContainer: function (el, container) {
    const elRect = el.getBoundingClientRect();
    let containerRect = null;
    if (container instanceof Element) {
      containerRect = container.getBoundingClientRect();
    } else {
      containerRect = {
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight,
        left: 0,
      };
    }
    return (
      elRect.top < containerRect.bottom &&
      elRect.bottom > containerRect.top &&
      elRect.right > containerRect.left &&
      elRect.left < containerRect.right
    );
  },

  // el: HTMLElement
  getOffsetTop: function (el) {
    let offset = 0;
    let parent = el;
    while (parent) {
      offset += parent.offsetTop || 0;
      parent = parent.offsetParent;
    }
    return offset;
  },

  //el: HTMLElement,containerEl: HTMLElement
  getOffsetTopDistance: function (el, containerEl) {
    return Math.abs(this.getOffsetTop(el) - this.getOffsetTop(containerEl));
  },
  hasClass: function (obj, cls) {
    return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
  },
  addClass: function (obj, cls) {
    if (!this.hasClass(obj, cls)) obj.className += " " + cls;
  },
  removeClass: function (obj, cls) {
    if (this.hasClass(obj, cls)) {
      const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
      obj.className = obj.className.replace(reg, " ");
    }
  },
};
export default utils;
